import { AppSetting } from 'dependencies/appsettings';
import { configureSystemImport } from 'app/infrastructure/hosting';
import { configureStore } from 'app/infrastructure/configure-store';
import { configure as configureReactHotkeys } from 'react-hotkeys';
import { connectToStore } from 'app/infrastructure/remote-data';
import { History } from 'history';

/**
 * Handle dev/prod initialization
 */
export function configureEnvironment(history: History): { store: any; history: History } {

  if (!AppSetting.ApiBaseUrl) {
    // eslint:disable-next-line
    throw new Error(`"ApiBaseUrl" in appsettings.json must be a URL pointing to the correct API endpoint.`);
  }

  configureReactHotkeys({ ignoreTags: [] });

  configureSystemImport();

  const store = configureStore();

  connectToStore(store);

  return { store, history };
}
